import { Grid, Paper } from '@mui/material';
import { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes as Switch, useLocation } from 'react-router-dom';
import AddEditAgents from '../screens/Authenticated/Agents/AddEditAgents/AddEditAgents';
import AgentList from '../screens/Authenticated/Agents/AgentList';
import BookingDetail from '../screens/Authenticated/BookingDetail';
import { EditBooking } from '../screens/Authenticated/BookingDetail/BookingDetailButtons/EditBooking';
import AddEditBookingMessage from '../screens/Authenticated/BookingMessage/AddEditBookingMessage';
import BookingMessageList from '../screens/Authenticated/BookingMessage/BookingMessageList';
import { Bookings } from '../screens/Authenticated/Bookings';
import AddEditBudget from '../screens/Authenticated/Budget/AddEditBudget/AddEditBudget';
import BudgetList from '../screens/Authenticated/Budget/BudgetList';
import AddEditpaymentConfiguration from '../screens/Authenticated/Configuration/PaymentConfiguration/AddEditPaymentConfiguration';
import PaymentConfigurationList from '../screens/Authenticated/Configuration/PaymentConfiguration/PaymentConfigurationList';
import AddEditRooms from '../screens/Authenticated/Configuration/Rooms/AddEditRooms';
import RoomsList from '../screens/Authenticated/Configuration/Rooms/RoomsList';
import AddEditVenue from '../screens/Authenticated/Configuration/Venue/AddEditVenue';
import VenueList from '../screens/Authenticated/Configuration/Venue/VenueList';
import AddEditCustomer from '../screens/Authenticated/Customer/AddEditCustomer/AddEditCustomer';
import CustomerList from '../screens/Authenticated/Customer/CustomerList';
import Dashboard from '../screens/Authenticated/Dashboard';
import SalesReport from '../screens/Authenticated/SalesReport';
import AddOnsList from '../screens/Authenticated/MasterData/AddOns/AddOnsList';
import AddEditEmailEventConfiguration from '../screens/Authenticated/MasterData/EmailEventConfiguration/AddEditEmailEventConfiguration';
import EmailEventConfigurationList from '../screens/Authenticated/MasterData/EmailEventConfiguration/EmailEventConfigurationList';
import EventTypeList from '../screens/Authenticated/MasterData/EventType/EventTypeList';
import LayoutList from '../screens/Authenticated/MasterData/Layout/LayoutList';
import LocationList from '../screens/Authenticated/MasterData/Location/LocationList';
import AddEditMailTemplate from '../screens/Authenticated/MasterData/MailTemplate/AddEditMailTemplate';
import MailTemplateList from '../screens/Authenticated/MasterData/MailTemplate/MailTemplateList';
import AddEditOrganization from '../screens/Authenticated/MasterData/Organization/AddEditOrganization/AddEditOrganization';
import OrganizationList from '../screens/Authenticated/MasterData/Organization/OrganizationList';
import AddEditParentOrganization from '../screens/Authenticated/MasterData/ParentOrganization/AddEditParentOrganization';
import ParentOrganizationList from '../screens/Authenticated/MasterData/ParentOrganization/ParentOrganizationList';
import PricePackageList from '../screens/Authenticated/MasterData/PricePackage/PricePackageList';
import RoomTypeList from '../screens/Authenticated/MasterData/RoomType/RoomTypeList';
import SurchargeList from '../screens/Authenticated/MasterData/Surcharge/SurchargeList';
import TaxCodeList from '../screens/Authenticated/MasterData/TaxCode/TaxCodeList';
import TaxGroupList from '../screens/Authenticated/MasterData/TaxGroup/TaxGroupList';
import AddEditTemplateSchedule from '../screens/Authenticated/MasterData/TemplateSchedule/AddEditTemplateSchedule';
import TemplateScheduleList from '../screens/Authenticated/MasterData/TemplateSchedule/TemplateScheduleList';
import VenueTypeList from '../screens/Authenticated/MasterData/VenueType/VenueTypeList';
import NewBooking from '../screens/Authenticated/NewBooking';
import ConsolidatedReports from '../screens/Authenticated/Reports/ConsolidatedReports';
import Reports from '../screens/Authenticated/Reports/Reports';
import RfqList from '../screens/Authenticated/RequestForQuote/RequestForQuoteList';
import { RFQDetails } from '../screens/Authenticated/RequestForQuote/RFQDetails';
import AddEditRole from '../screens/Authenticated/Role/RoleList/AddEditRole/AddEditRole';
import Privilege from '../screens/Authenticated/Role/RoleList/Privilege';
import RoleList from '../screens/Authenticated/Role/RoleList/RoleList';
import AddEditSystemMessage from '../screens/Authenticated/SystemMessage/AddEditSystemMessage';
import SystemMessageList from '../screens/Authenticated/SystemMessage/SystemMessageList';
import UserManagement from '../screens/Authenticated/UserManagement';
import UserProfile from '../screens/Authenticated/UserProfile';
import ForgotPassword from '../screens/Authentication/ForgotPassword';
import Login from '../screens/Authentication/Login';
import ResetPin from '../screens/Authentication/ResetPin';
import FirstTimeChangePassword from '../screens/Authentication/FirstTimeChangePassword';
import SetPasswordAfterUpgrade from '../screens/Authentication/SetPasswordAfterUpgrade';
import axiosInstance from '../utils/axios';
import { routes } from '../utils/constants/routes';
import { URLS } from '../utils/constants/urls';
import { Authenticated } from '../utils/redux';
import {
  defaultLanguage,
  handleLanguageChange,
  setLanguageList,
  setSelectedLanguage,
} from '../utils/redux/reducer/authentication-slice';
import AuthLayout from './AuthLayout';

import MealPlansList from 'screens/Authenticated/MasterData/MealPlan/MealPlansList';

import ErrorPage from 'components/ErrorPage/ErrorPage';
import PageNotFound from 'components/PageNotFound/PageNotFound';
import AddEditCompanyMaster from 'screens/Authenticated/SalesManagement/CompanyMaster/AddEditCompanyMaster';
import CompanyMasterList from 'screens/Authenticated/SalesManagement/CompanyMaster/CompanyMasterList';
import AddEditSalesCalls from 'screens/Authenticated/SalesManagement/SalesCalls/AddEditSalesCalls/AddEditSalesCalls';
import TaskList from 'screens/Authenticated/TaskList/TaskList';
import AddOnCategoriesList from 'screens/Authenticated/MasterData/AddOnCategories/AddOnCategoriesListing';
import EditAddOnCategory from 'screens/Authenticated/MasterData/AddOnCategories/EditAddOnCategories';
import AddressList from 'screens/Authenticated/MasterData/Address/AddressList';
import EditPaymentMethod from 'screens/Authenticated/MasterData/PaymentMethods/EditPaymentMethods';
import PaymentMethodsList from 'screens/Authenticated/MasterData/PaymentMethods/PaymentMethodListing';
import AvailableOrganisations from 'screens/Authenticated/NewBooking/AvailableOrganisations';
import OrganisationDetails from 'screens/Authenticated/NewBooking/OrganisationDetails';
import { identifiers } from 'utils/constants/identifiers';
import { fetchFromStorage, removeFromStorage } from 'utils/storage';
import BookingList from '../screens/Authenticated/BookingList';
import BookingEventSource from '../screens/Authenticated/BookingEventSource/index';
import AddEditVenueConfiguration from '../screens/Authenticated/Configuration/VenueConfiguration/AddEditVenueConfiguration/AddEditVenueConfiguration';
import BulkCreateVenueConfiguration from '../screens/Authenticated/Configuration/VenueConfiguration/BulkCreateVenueConfiguration';
import VenueConfigurationList from '../screens/Authenticated/Configuration/VenueConfiguration/VenueConfigurationList';
import EditOrgMasterData from '../screens/Authenticated/MasterData/OrgMasterData/EditOrgMasterData/EditOrgMasterData';
import OrgMasterDataList from '../screens/Authenticated/MasterData/OrgMasterData/OrgMasterDataList';
import PartOfDayList from '../screens/Authenticated/MasterData/PartOfDay/PartOfDayList';
import IndustryTypeList from 'screens/Authenticated/MasterData/IndustryType/IndustryTypeList';
import AddBeo from '../screens/Authenticated/BEO/AddBeo';
import SalesListTab from 'screens/Authenticated/SalesManagement/SalesCalls/SalesListTab';

// IDS Configurations
import { EventMappingsList } from '../screens/Authenticated/IDSConfigurations/EventMappings';
import { VenueMappingsList } from '../screens/Authenticated/IDSConfigurations/VenueMappings';
import { LayoutMappingsList } from '../screens/Authenticated/IDSConfigurations/LayoutMappings';
import { StatusMappingsList } from '../screens/Authenticated/IDSConfigurations/StatusMappings';
import IdsLogsList from '../screens/Authenticated/IDSConfigurations/IdsLogs/IdsLogsList';
import OperaLogsList from '../screens/Authenticated/OperaLogs/OperaLogsList';
import SuperAdminBookingLookup from '../screens/Authenticated/SuperAdminBookingLookup';
import SuperAdminBookingLineItemEdit from '../screens/Authenticated/SuperAdminBookingLookup/SuperAdminBookingLineItemEdit';
import PropertyOnboarding from '../screens/Authenticated/PropertyOnboarding';
import PropertyReadinessDashboard from '../screens/Authenticated/PropertyReadinessDashboard';
import { SA_BOOKING_LINE_ITEM_EDIT_ROUTE } from '../utils/constants/routes';

const Root: FC = () => {
  let location = useLocation();

  const isLogin = useSelector(Authenticated);
  const { from } = location.state || { from: { pathname: routes.bookings } };
  return isLogin ? <Navigate to={from} /> : <Navigate to={routes.login} />;
};

const AuthenticatedScreens: FC<{ Component: any }> = ({ Component }) => {
  let location = useLocation();
  const isLogin = useSelector(Authenticated);
  const org = fetchFromStorage(identifiers.organization) as any;
  if (!location.pathname.includes(routes.editOrganization)) {
    removeFromStorage('orgTabValue');
  }

  if (isLogin) {
    if (org === '*') {
      if (location.pathname.includes(routes.addOrganization) || location.pathname.includes('/profile'))
        return <AuthLayout Component={Component} />;
      else return <ErrorPage />;
    } else {
      return <AuthLayout Component={Component} />;
    }
  } else {
    return <Navigate to={routes.login} />;
  }
};

const Routes: FC = () => {
  const dispatch = useDispatch();
  const lang = useSelector(defaultLanguage);
  const getLanguageList = useCallback(async () => {
    const { status, data } = await axiosInstance.get(URLS.language);
    if (status === 200) {
      const languageList = data.map((item: any) => ({ text: item.text, value: item.value }));
      dispatch(setLanguageList(languageList));
      if (lang.value === '') {
        dispatch(setSelectedLanguage({ label: data[0].text, value: data[0].value }));
        dispatch(handleLanguageChange({ label: data[0].text, value: data[0].value }) as any);
      } else {
        dispatch(handleLanguageChange(lang) as any);
      }
    }
  }, [dispatch]);

  useEffect(() => {
    getLanguageList();
  }, [getLanguageList]);

  return (
    <Grid item container flexDirection="column">
      <Grid className="pageWrapper" item sx={{ width: '100%' }}>
        <Paper elevation={0} square={false} className="paperWrapper">
          <Switch>
            <Route path={routes.root} element={<Root />} />
            <Route path={routes.login} element={<Login />} />
            <Route path={routes.forgotPassword} element={<ForgotPassword />} />
            <Route path={routes.resetPassword} element={<ResetPin />} />
            <Route path={routes.setPasswordAfterUpgrade} element={<SetPasswordAfterUpgrade />} />
            <Route path={routes.firstTimeChangePassword} element={<FirstTimeChangePassword />} />
            <Route path={routes.addRole} element={<AuthenticatedScreens Component={AddEditRole} />} />
            <Route path={`${routes.editRole}/:id`} element={<AuthenticatedScreens Component={AddEditRole} />} />
            <Route path={`${routes.privilige}/:id`} element={<AuthenticatedScreens Component={Privilege} />} />
            <Route path={routes.roleList} element={<AuthenticatedScreens Component={RoleList} />} />
            <Route path={routes.profile} element={<AuthenticatedScreens Component={UserProfile} />} />
            <Route path={routes.users} element={<AuthenticatedScreens Component={UserManagement} />} />
            <Route path={routes.agentList} element={<AuthenticatedScreens Component={AgentList} />} />
            <Route path={routes.addAgent} element={<AuthenticatedScreens Component={AddEditAgents} />} />
            <Route path={`${routes.editAgent}/:id`} element={<AuthenticatedScreens Component={AddEditAgents} />} />
            <Route path={routes.venueType} element={<AuthenticatedScreens Component={VenueTypeList} />} />
            <Route path={routes.budgetList} element={<AuthenticatedScreens Component={BudgetList} />} />
            <Route path={routes.addBudget} element={<AuthenticatedScreens Component={AddEditBudget} />} />
            <Route path={`${routes.editBudget}/:id`} element={<AuthenticatedScreens Component={AddEditBudget} />} />
            <Route path={routes.customerList} element={<AuthenticatedScreens Component={CustomerList} />} />
            <Route path={routes.addCustomer} element={<AuthenticatedScreens Component={AddEditCustomer} />} />
            <Route path={`${routes.editCustomer}/:id`} element={<AuthenticatedScreens Component={AddEditCustomer} />} />
            <Route path={routes.addCustomer} element={<AuthenticatedScreens Component={AddEditCustomer} />} />
            <Route path={`${routes.rfqList}`} element={<AuthenticatedScreens Component={RfqList} />} />
            <Route path={`${routes.viewRfq}/:id`} element={<AuthenticatedScreens Component={RFQDetails} />} />
            <Route path={routes.location} element={<AuthenticatedScreens Component={LocationList} />} />
            <Route path={routes.addOns} element={<AuthenticatedScreens Component={AddOnsList} />} />
            <Route path={routes.eventType} element={<AuthenticatedScreens Component={EventTypeList} />} />
            <Route path={routes.roomType} element={<AuthenticatedScreens Component={RoomTypeList} />} />
            <Route path={routes.templateSchedule} element={<AuthenticatedScreens Component={TemplateScheduleList} />} />
            <Route
              path={`${routes.editTemplateSchedule}/:id`}
              element={<AuthenticatedScreens Component={AddEditTemplateSchedule} />}
            />
            <Route path={routes.taxCode} element={<AuthenticatedScreens Component={TaxCodeList} />} />
            <Route path={routes.taxGroup} element={<AuthenticatedScreens Component={TaxGroupList} />} />
            <Route path={routes.surcharge} element={<AuthenticatedScreens Component={SurchargeList} />} />
            <Route path={routes.layout} element={<AuthenticatedScreens Component={LayoutList} />} />

            <Route path={routes.systemMessage} element={<AuthenticatedScreens Component={SystemMessageList} />} />
            <Route
              path={`${routes.editSystemMessage}/:id`}
              element={<AuthenticatedScreens Component={AddEditSystemMessage} />}
            />
            <Route path={routes.bookingMessage} element={<AuthenticatedScreens Component={BookingMessageList} />} />
            <Route
              path={`${routes.editBookingMessage}/:id`}
              element={<AuthenticatedScreens Component={AddEditBookingMessage} />}
            />
            <Route path={routes.pricePackage} element={<AuthenticatedScreens Component={PricePackageList} />} />
            <Route path={routes.mailTemplate} element={<AuthenticatedScreens Component={MailTemplateList} />} />
            <Route
              path={`${routes.editMailTemplate}/:id`}
              element={<AuthenticatedScreens Component={AddEditMailTemplate} />}
            />
            <Route
              path={routes.parentOrganization}
              element={<AuthenticatedScreens Component={ParentOrganizationList} />}
            />
            <Route
              path={routes.addParentOrganization}
              element={<AuthenticatedScreens Component={AddEditParentOrganization} />}
            />
            <Route
              path={`${routes.editParentOrganization}/:id`}
              element={<AuthenticatedScreens Component={AddEditParentOrganization} />}
            />
            <Route path={routes.rooms} element={<AuthenticatedScreens Component={RoomsList} />} />
            <Route path={routes.addRooms} element={<AuthenticatedScreens Component={AddEditRooms} />} />
            <Route path={`${routes.editRooms}/:id`} element={<AuthenticatedScreens Component={AddEditRooms} />} />
            <Route path={routes.venue} element={<AuthenticatedScreens Component={VenueList} />} />
            <Route path={routes.addVenue} element={<AuthenticatedScreens Component={AddEditVenue} />} />
            <Route path={`${routes.editVenue}/:id`} element={<AuthenticatedScreens Component={AddEditVenue} />} />
            <Route
              path={routes.paymentConfig}
              element={<AuthenticatedScreens Component={PaymentConfigurationList} />}
            />
            <Route
              path={routes.addPaymentConfig}
              element={<AuthenticatedScreens Component={AddEditpaymentConfiguration} />}
            />
            <Route
              path={`${routes.editPaymentConfig}/:id`}
              element={<AuthenticatedScreens Component={AddEditpaymentConfiguration} />}
            />
            <Route
              path={routes.emailEventConfig}
              element={<AuthenticatedScreens Component={EmailEventConfigurationList} />}
            />
            <Route
              path={routes.addEmailEventConfig}
              element={<AuthenticatedScreens Component={AddEditEmailEventConfiguration} />}
            />
            <Route
              path={`${routes.editEmailEventConfig}/:id`}
              element={<AuthenticatedScreens Component={AddEditEmailEventConfiguration} />}
            />
            <Route path={`${routes.bookings}`} element={<AuthenticatedScreens Component={Bookings} />} />
            <Route path={`${routes.addBooking}`} element={<AuthenticatedScreens Component={NewBooking} />} />
            <Route path={`${routes.addBooking}/:id`} element={<AuthenticatedScreens Component={NewBooking} />} />
            <Route path={`${routes.bookings}/:id`} element={<AuthenticatedScreens Component={BookingDetail} />} />
            <Route path={routes.reports} element={<AuthenticatedScreens Component={Reports} />} />
            <Route
              path={routes.consolidatedReports}
              element={<AuthenticatedScreens Component={ConsolidatedReports} />}
            />

            <Route path={routes.organization} element={<AuthenticatedScreens Component={OrganizationList} />} />
            <Route path={routes.addOrganization} element={<AuthenticatedScreens Component={AddEditOrganization} />} />
            <Route
              path={`${routes.editOrganization}/:id`}
              element={<AuthenticatedScreens Component={AddEditOrganization} />}
            />

            <Route path={`${routes.editBooking}/:id`} element={<AuthenticatedScreens Component={EditBooking} />} />
            <Route path={routes.dashboard} element={<AuthenticatedScreens Component={Dashboard} />} />
            <Route
              path={routes.venueConfiguration}
              element={<AuthenticatedScreens Component={VenueConfigurationList} />}
            />
            <Route
              path={routes.addVenueConfiguration}
              element={<AuthenticatedScreens Component={AddEditVenueConfiguration} />}
            />
            <Route
              path={routes.bulkCreateVenueConfiguration}
              element={<AuthenticatedScreens Component={BulkCreateVenueConfiguration} />}
            />
            <Route
              path={`${routes.editVenueConfiguration}/:id`}
              element={<AuthenticatedScreens Component={AddEditVenueConfiguration} />}
            />
            <Route path={routes.bookingList} element={<AuthenticatedScreens Component={BookingList} />} />
            <Route path={routes.bookingEventSource} element={<AuthenticatedScreens Component={BookingEventSource} />} />
            <Route
              path={routes.deletedBookings}
              element={<Navigate to={`${routes.bookingList}?view=deleted`} replace />}
            />

            <Route path={routes.orgMasterData} element={<AuthenticatedScreens Component={OrgMasterDataList} />} />
            <Route path={routes.partOfDay} element={<AuthenticatedScreens Component={PartOfDayList} />} />
            <Route
              path={`${routes.orgMasterData}/:id`}
              element={<AuthenticatedScreens Component={EditOrgMasterData} />}
            />
            <Route path="*" element={<PageNotFound />} />
            <Route path="errorPage" element={<ErrorPage />} />

            <Route path={routes.mealPlans} element={<AuthenticatedScreens Component={MealPlansList} />} />
            <Route path={`${routes.addBeo}/:id`} element={<AuthenticatedScreens Component={AddBeo} />} />
            <Route path={routes.address} element={<AuthenticatedScreens Component={AddressList} />} />
            <Route path={routes.addAddress} element={<Navigate to={routes.address} replace />} />
            <Route path={`${routes.editAddress}/:id`} element={<Navigate to={routes.address} replace />} />
            <Route path={routes.availableOrgs} element={<AuthenticatedScreens Component={AvailableOrganisations} />} />
            <Route path={routes.availableVenues} element={<AuthenticatedScreens Component={OrganisationDetails} />} />
            <Route path={routes.companyMasters} element={<AuthenticatedScreens Component={CompanyMasterList} />} />
            <Route
              path={routes.addCompanyMasters}
              element={<AuthenticatedScreens Component={AddEditCompanyMaster} />}
            />
            <Route
              path={`${routes.editCompanyMasters}/:id`}
              element={<AuthenticatedScreens Component={AddEditCompanyMaster} />}
            />
            <Route path={routes.salesReport} element={<AuthenticatedScreens Component={SalesReport} />} />
            <Route path={routes.taskList} element={<AuthenticatedScreens Component={TaskList} />} />
            <Route path={routes.salesManagement} element={<AuthenticatedScreens Component={SalesListTab} />} />
            <Route path={routes.addSalesManagement} element={<AuthenticatedScreens Component={AddEditSalesCalls} />} />
            <Route
              path={`${routes.editSalesManagement}/:id`}
              element={<AuthenticatedScreens Component={AddEditSalesCalls} />}
            />
            <Route
              path={`${routes.paymentMethods}`}
              element={<AuthenticatedScreens Component={PaymentMethodsList} />}
            />
            <Route
              path={`${routes.paymentMethods}/:id`}
              element={<AuthenticatedScreens Component={EditPaymentMethod} />}
            />
            <Route
              path={`${routes.addOnCategoriesList}`}
              element={<AuthenticatedScreens Component={AddOnCategoriesList} />}
            />
            <Route
              path={`${routes.addOnCategories}`}
              element={<AuthenticatedScreens Component={EditAddOnCategory} />}
            />
            <Route
              path={`${routes.addOnCategories}/:id`}
              element={<AuthenticatedScreens Component={EditAddOnCategory} />}
            />
            <Route path={routes.industryType} element={<AuthenticatedScreens Component={IndustryTypeList} />} />

            {/* IDS Configurations */}
            <Route path={routes.eventMappings} element={<AuthenticatedScreens Component={EventMappingsList} />} />
            <Route path={routes.venueMappings} element={<AuthenticatedScreens Component={VenueMappingsList} />} />
            <Route path={routes.layoutMappings} element={<AuthenticatedScreens Component={LayoutMappingsList} />} />
            <Route path={routes.statusMappings} element={<AuthenticatedScreens Component={StatusMappingsList} />} />

            <Route path={routes.idsLogs} element={<AuthenticatedScreens Component={IdsLogsList} />} />

            <Route path={routes.operaLogs} element={<AuthenticatedScreens Component={OperaLogsList} />} />

            <Route path={routes.saBookingLookup} element={<AuthenticatedScreens Component={SuperAdminBookingLookup} />} />
            <Route path={routes.propertyOnboarding} element={<AuthenticatedScreens Component={PropertyOnboarding} />} />
            <Route
              path={routes.propertyReadinessDashboard}
              element={<AuthenticatedScreens Component={PropertyReadinessDashboard} />}
            />
            <Route
              path={SA_BOOKING_LINE_ITEM_EDIT_ROUTE}
              element={<AuthenticatedScreens Component={SuperAdminBookingLineItemEdit} />}
            />
          </Switch>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Routes;
